module.exports = __webpack_public_path__ + "static/media/integral_card_1.891dc773.png";